"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHGame = exports.KHScaleMode = void 0;
const KHLocalStorageManager_1 = require("./KHLocalStorageManager");
var KHScaleMode;
(function (KHScaleMode) {
    KHScaleMode[KHScaleMode["ScaleMax"] = 0] = "ScaleMax";
    KHScaleMode[KHScaleMode["ScalePixelPerfect"] = 1] = "ScalePixelPerfect";
    KHScaleMode[KHScaleMode["NoScale"] = 2] = "NoScale";
})(KHScaleMode || (exports.KHScaleMode = KHScaleMode = {}));
class KHGame extends Phaser.Game {
    setKHConfig(config) {
        config.alwaysMaxScale = config.alwaysMaxScale || !config.defaultScale;
        config.defaultScale = config.defaultScale || 1;
        config.maxScale = config.maxScale || Infinity;
        config.minScale = config.minScale || 1;
        this.khConfig = config;
    }
    constructor(phaserConfig, khConfig) {
        super(phaserConfig);
        this.storageManager = new KHLocalStorageManager_1.KHLocalStorageManager();
        this.width = Number(this.config.width);
        this.height = Number(this.config.height);
        this.setKHConfig(khConfig);
        this.events.on(Phaser.Core.Events.READY, () => {
            var _a;
            if (this.config.parent instanceof HTMLElement) {
                this.parentElement = this.config.parent.parentElement;
            }
            else if (typeof this.config.parent === 'string') {
                this.parentElement = (_a = document.getElementById(this.config.parent)) === null || _a === void 0 ? void 0 : _a.parentElement;
            }
            this.updateKHScale();
        });
        window.addEventListener('resize', e => {
            this.updateKHScale();
        });
    }
    updateKHScale() {
        if (this.khConfig.scaleMode == KHScaleMode.NoScale)
            return;
        if (!this.khConfig.alwaysMaxScale)
            return;
        if (this.parentElement == null) {
            console.warn("Null parent element.");
        }
        let scale = this.maxScale();
        // If it's not always default, resize should only trigger update if the window
        // size has made the content no longer fit.
        if (!this.khConfig.alwaysMaxScale && scale >= this.scaleFactor) {
            return;
        }
        this.setScale(this.khConfig.maxScale);
    }
    maxScale() {
        if (this.parentElement == null)
            return 1;
        const maxWidthScale = this.parentElement.offsetWidth / this.scale.gameSize.width;
        const maxHeightScale = this.parentElement.offsetHeight / this.scale.gameSize.height;
        let scale = Math.min(maxWidthScale, maxHeightScale);
        switch (this.khConfig.scaleMode) {
            case KHScaleMode.ScalePixelPerfect:
                scale = (Math.floor(scale));
                break;
        }
        return scale;
    }
    setScale(scale) {
        scale = Math.max(this.khConfig.minScale, Math.min(this.khConfig.maxScale, scale));
        scale = Math.min(this.maxScale(), scale);
        this.scaleFactor = Math.max(this.khConfig.minScale, Math.min(this.khConfig.maxScale, scale));
        this.scale.setZoom(this.scaleFactor);
        this.canvas.style.width = `${this.width * this.scaleFactor}px`;
        this.canvas.style.height = `${this.height * this.scaleFactor}px`;
    }
    getScale() {
        return this.scaleFactor;
    }
    increaseScale(amt = 1) {
        this.setScale(this.scaleFactor + amt);
    }
    decreaseScale(amt = 1) {
        this.setScale(this.scaleFactor - amt);
    }
}
exports.KHGame = KHGame;
